/** Device serial numbers are kept as text, comma or line separated. */
export function splitSerials(text) {
  return String(text || '').split(/[\s,;]+/).filter(Boolean);
}

/** The date `months` later as YYYY-MM-DD; a missing day becomes the month's last. */
export function addMonthsIso(iso, months) {
  const [y, m, d] = iso.split('-').map(Number);
  const lastDay = new Date(Date.UTC(y, m - 1 + months + 1, 0)).getUTCDate();
  const date = new Date(Date.UTC(y, m - 1 + months, Math.min(d, lastDay)));
  return date.toISOString().slice(0, 10);
}
